import { render } from "./DomainSearch.vue?vue&type=template&id=df91663c"
import script from "./DomainSearch.vue?vue&type=script&lang=js"
export * from "./DomainSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__